import { http } from '../../config/axios'

export default function postAplicarVoucher(hash: string): Promise<string> {
  return http
    .post('api/voucher/aplicar', { hash })
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro postAplicarVoucher', error)
      throw Error(error.response.data)
    })
}
